import { useQuery } from '@tanstack/react-query'
import { publicApi } from '@/lib/api'

import { SignatureQueryKey } from '../helpers/signature-query-key'
import { useAccessToken } from '@/features/auth/state/auth'

export function useFetchSignatureById(id_client?: string) {
  const token = useAccessToken()

  return useQuery({
    queryKey: SignatureQueryKey(id_client),
    queryFn: async () => {
      if (!id_client) throw new Error('Signature ID_client is required')

      const response = await publicApi.get(`/signatures/cnpj/${id_client}`, {
        headers: { Authorization: `Bearer ${token}` }
      })

      if (response.data) {
        return response.data
      } else {
        throw new Error('Signature not found')
      }
    },
    enabled: Boolean(token && id_client)
  })
}
